import type { BadgeProps } from '@insio/ui-toolkit';
import type { PaymentStatus, ValidationStatus } from '@/graphql';

export type BadgeColor = NonNullable<BadgeProps['color']>;

const PAYMENT_STATUS_COLOR: Record<string, BadgeColor> = {
  PAID: 'success',
  PARTIALLY_PAID: 'warning',
  UNPAID: 'neutral',
  OVERDUE: 'error'
};

const VALIDATION_STATUS_COLOR: Record<string, BadgeColor> = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  PENDING: 'info',
  WAITING_FOR_CREDITS: 'warning'
};

export function paymentStatusColor(status: string): BadgeColor {
  return PAYMENT_STATUS_COLOR[status as PaymentStatus] ?? 'neutral';
}

export function validationStatusColor(status: string): BadgeColor {
  return VALIDATION_STATUS_COLOR[status as ValidationStatus] ?? 'neutral';
}
